import React from 'react';
import createReactClass from 'create-react-class';
import auth0 from './helpers/auth0';
import LoginInProcess from './components/LoginInProcess';
import UserIsNotAllowed from './components/UserIsNotAllowed';
import Main from './components/Main';

const App = createReactClass({
  componentWillMount() {
    
  },

  componentDidMount () {
    auth0.lock.on('authenticated', (authResult) => {
      if(!authResult || !authResult.accessToken) {
        return;
      }
      
      window.location.hash = '';
      auth0.setTokenData(authResult.accessToken);
      this.forceUpdate();

      auth0.lock.hide();
    });
  },

  render() {
    if (!auth0.isAuthenticated()) {
      return (<LoginInProcess />);
    }

    if(!auth0.isUserWhitelisted()) {
      return (<UserIsNotAllowed />);
    }

    return (<Main />);
  }
});

export default App;



// WEBPACK FOOTER //
// ./src/App.js